import { CatalogBuilder } from "../../../commonGroupModuleStructure/catalogBuilder";
import { getUserPagingData } from "./apiCall";
import { UserKeys } from "./entity";

export const User = () => {

  return (
    <CatalogBuilder
      headerLabel={"User"}
      headerButtonLabel={"Add User"}

      getPagingData={getUserPagingData}
      pagingAPIKey={UserKeys.paging}

      visibleColumns={{
        MappingReferenceId: false
      }}
      onModeClickPath="/user/details/"
      disableDeleteAction
    />
  );
};
